import { isEmpty } from "./array";

export function is(objects = [], types = [], { joinIntoArray = true } = {}) {
    if (types === null) return objects === null || objects === undefined;

    if (Array.isArray(types) && types.includes(null) && is(objects, null))
        return true;

    if (is(objects, null)) return false;

    objects = [objects];

    if (typeof types === "string") types = [types];

    let result = false;

    const verify = (list, check, func = "every") =>
        list[func]((object) => {
            if (joinIntoArray && Array.isArray(object))
                return verify(object, check);

            return check(object);
        });

    types.forEach((type) => {
        if (result === true) return;

        if (type && typeof type !== "string") {
            result = verify(objects, (object) => object instanceof type);
            return;
        } else if (type === "array") {
            result = objects.every((object) => Array.isArray(object));
            return;
        } else if (type === "date") {
            result = verify(objects, (object) => is(object, Date));
            return;
        }

        if (type === "object" && verify(objects, Array.isArray, "some")) return;

        result = verify(objects, (object) => typeof object === type);
    });

    return result;
}

export function isEmptyObject(obj) {
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
}

export function merge(first, second, ignore = []) {
    const can = (object) =>
        typeof object === "object" && !Array.isArray(object);

    if (!can(first) || !can(second)) return null;

    const result = {};

    const run = (list) =>
        Object.keys(list).forEach((key) => {
            if (ignore.includes(key)) return;

            const item = list[key];

            if (item === null || item === undefined) return;

            if (is(item, "object", { joinIntoArray: false })) {
                if (!result[key]) result[key] = {};

                result[key] = merge(result[key], item);

                return;
            }

            result[key] = item;
        });

    run(first);
    run(second);

    return result;
}

export function isObject(object) {
    if (!is(object, "object")) return false;

    return Object.keys(object).length > 0;
}

export function isNull(object) {
    return !object || object === "null";
}
export function getValueOrDefaultNull(data, field, valueField = "value") {
    if (data && data.length === 0) return undefined;
    if (!field) return data ? data : undefined;

    return data[field] ? data[field][valueField] : undefined;
}

export function getValueOrDefaultNullObject(data, field, valueField = "value") {
    if (!data || (data && data.length === 0)) return undefined;
    return data.map((dado) => {
        return dado.value;
    });
}

export function getValueOrDefault(object, defaultValue) {
    if (typeof object === "string" || isEmpty(object))
        return object ? object : defaultValue;

    const { parent, children, path } = object;

    if (!parent) return defaultValue;

    if (children) {
        let value = parent;

        children.forEach((child) => {
            if (!value || !value.hasOwnProperty(child)) {
                value = defaultValue;

                return;
            }

            value = value[child];
        });

        return value;
    } else if (path) {
        return getValueOrDefault(
            { parent, children: path.split(".") },
            defaultValue
        );
    }

    return defaultValue;
}

export function filterKeys(object, keys = {}) {
    keys = {
        values: [],
        allow: true,
        ...keys,
    };

    return Object.keys(object)
        .filter((key) => keys.values.includes(key) === keys.allow)
        .reduce((obj, key) => {
            obj[key] = object[key];

            return obj;
        }, {});
}

export function deleteNullFields(object) {
    Object.keys(object).forEach(async (key) => {
        const value = object[key];

        if (isNull(key) || isNull(value) || isEmpty(value)) {
            delete object[key];
        }
    });
}

export function dynamicSort(property) {
    var sortOrder = 1;

    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a, b) {
        var result =
            a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
    };
}

export function getKey(object, index = 0) {
    if (isEmpty(object)) return null;

    const key = Array.isArray(object)
        ? object[index]
        : Object.keys(object)[index];

    return { name: key, index, data: object[key] };
}

export function getFistObject(object) {
    if (isEmpty(object)) return null;

    for (const [idx, obj] of Object.entries(object)) {
        if (typeof (obj) == "object" && !Array.isArray(obj)) {
            return { name: idx, data: obj }
        }
    }
    return null;
}

export function toArray(object) {
    if (!object) return []
    return Object.keys(object).map((key) => ({
        id: key,
        data: object[key],
    }));
}

export function get_Transportadores(object) {
    if (object.motoristas) {
        return Object.keys(object.motoristas).length
    }
    else if (object.entregadores) {
        return Object.keys(object.entregadores).length
    }
    return 0
}

export function copyObject(object) {
    return JSON.parse(JSON.stringify(object))
}

export function filtrarObjecto(object, vetor) {
    const filtro = vetor.reduce((vetor, element) => {
        if (element.active) vetor.push(element.value)
        return vetor
    }, [])

    const array = Object.entries(object);
    const filtered = array.filter(([key, value]) => filtro.indexOf(key) >= 0);
    object = Object.fromEntries(filtered);
    return object
}

export function arrayFilterRemove(array, remove) {
    return array.map((element, index) => {
        element.active = false
        element.id = index
        if (element.cidade == "DESCONHECIDA") element.cidade = element.sigla
        remove.map((remove) => {
            delete element[remove]
        })
        return element
    })
}

export const getDifferences = (obj1, obj2) => {

    return Object.fromEntries(Object.entries(obj1).filter(field => {

        if (isObject(field?.[1])) {
            return Object.values(getDifferences(field?.[1], obj2?.[field?.[0]])).length
        }
        return field?.[1]?.toString() !== obj2?.[field[0]]?.toString()
    }))
}

export function flattenObject(obj, prefix = "", result = {}) {
    if (obj === null || obj === undefined) return result;

    Object.entries(obj).forEach(([key, value]) => {
        const newKey = prefix ? `${prefix}.${key}` : key;

        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                flattenObject(item, `${newKey}.${index}`, result);
            });
        } else if (typeof value === "object") {
            flattenObject(value, newKey, result);
        } else {
            result[newKey] = value;
        }
    });

    return result;
}